module.exports = __webpack_public_path__ + "assets/pdf.3962cdb6.svg";